const sh =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse";

const AttachmentShimmer = () => (
  <div className="flex flex-col h-full">
    <div className="flex items-center justify-between h-[50px] px-3 border-b border-border-gray dark:border-border-gray-dk shrink-0">
      <div className="flex items-center gap-2">
        <h3 className="text-md font-semibold text-verba-indigo dark:text-verba-indigo-dk">
          Attachments
        </h3>
        <div className={`w-5 h-4 rounded-sm ${sh}`} />
      </div>
      <div className={`w-[85px] h-3.5 rounded ${sh}`} />
    </div>
    <div className="flex flex-col gap-4 px-3 py-4">
      <div className="flex items-center gap-2 flex-wrap">
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            className={`w-[60px] h-[60px] rounded-lg ${sh}`}
            style={{ animationDelay: `${index * 80}ms` }}
          />
        ))}
      </div>
    </div>
  </div>
);

export default AttachmentShimmer;
